module.exports = __webpack_public_path__ + "static/media/header.c272a552.jpg";